import { generateQuestions, openAndTest, processFile, searchAndSummarize } from './features'

export const chatToDocTemplate = {
  id: 'd699326b-b73b-4cc8-83d6-6de4efbe74d8',
  status: 'draft',
  createdBy: '5c1e8559-6586-487b-b60d-c680dcab9bcf',
  createdDate: '2023-11-07T13:53:17.662Z',
  modifiedBy: '2fd7fdcf-9779-444a-aa94-cc51396f16f2',
  modifiedDate: '2024-04-25T12:24:58.924Z',
  sharedWith: [],
  name: 'Chat to Document',
  version: '3.2',
  description: 'Ask questions and find information in a document',
  audience: [],
  iconUrl: 'https://cdn.dev.workgrid.com/templates/d699326b-b73b-4cc8-83d6-6de4efbe74d8/icon.png',
  dataSources: [],
  features: [openAndTest, searchAndSummarize, processFile, generateQuestions]
}
